export default __webpack_public_path__ + "static/media/png.a77bee4b.svg";